import { useState, useEffect, useCallback } from 'react';
import { useMsal } from '@azure/msal-react';
import { apiRequest } from '../../authConfig.js';
import { adminGetUsers, adminGetLogs } from '../../api.js';
import styles from './AdminTable.module.css';

export default function Logs() {
  const { instance, accounts } = useMsal();
  const [users, setUsers] = useState([]);
  const [logs, setLogs] = useState([]);
  const [filterUserId, setFilterUserId] = useState('');
  const [loading, setLoading] = useState(true);

  const getToken = useCallback(async () => {
    const resp = await instance.acquireTokenSilent({ ...apiRequest, account: accounts[0] });
    return resp.idToken;
  }, [instance, accounts]);

  useEffect(() => {
    getToken()
      .then((token) => adminGetUsers(token))
      .then(setUsers)
      .catch(console.error);
  }, [getToken]);

  const fetchLogs = useCallback(async () => {
    setLoading(true);
    try {
      const token = await getToken();
      const data = await adminGetLogs(token, {
        userId: filterUserId || undefined,
        limit: 100,
      });
      setLogs(data);
    } catch (err) {
      console.error('Failed to fetch logs:', err);
    } finally {
      setLoading(false);
    }
  }, [getToken, filterUserId]);

  useEffect(() => {
    fetchLogs();
  }, [fetchLogs]);

  function formatDate(iso) {
    if (!iso) {
      return '—';
    }
    return new Date(iso).toLocaleString('pt-PT');
  }

  function getUserLabel(userId) {
    const u = users.find((u) => u.userId === userId);
    return u ? (u.displayName || u.email) : userId;
  }

  return (
    <div>
      <div className={styles.header}>
        <h1 className={styles.title}>Logs de Acesso</h1>
        <button className={styles.refreshBtn} onClick={fetchLogs}>
          Actualizar
        </button>
      </div>

      <div style={{ marginBottom: '1rem', display: 'flex', alignItems: 'center', gap: '0.75rem' }}>
        <label htmlFor="log-filter" style={{ fontWeight: 500 }}>
          Filtrar por utilizador:
        </label>
        <select
          id="log-filter"
          value={filterUserId}
          onChange={(e) => setFilterUserId(e.target.value)}
          style={{ padding: '0.4rem 0.8rem', borderRadius: '6px', border: '1px solid #d0d0d0' }}
        >
          <option value="">Todos</option>
          {users.map((u) => (
            <option key={u.userId} value={u.userId}>
              {u.displayName || u.email}
            </option>
          ))}
        </select>
      </div>

      {loading ? (
        <div className={styles.loading}>A carregar logs...</div>
      ) : (
        <div className={styles.tableWrapper}>
          <table className={styles.table}>
            <thead>
              <tr>
                <th>Timestamp</th>
                <th>Utilizador</th>
                <th>Relatório</th>
                <th>Acção</th>
                <th>IP</th>
              </tr>
            </thead>
            <tbody>
              {logs.map((log, i) => (
                <tr key={i}>
                  <td className={styles.mono} style={{ whiteSpace: 'nowrap' }}>
                    {formatDate(log.timestamp)}
                  </td>
                  <td>{getUserLabel(log.userId)}</td>
                  <td>{log.reportName || log.reportId}</td>
                  <td>
                    <span className={`${styles.badge} ${log.action === 'TOKEN_GENERATED' ? styles.badgeBlue : styles.badgeGreen}`}>
                      {log.action}
                    </span>
                  </td>
                  <td className={styles.mono}>{log.ip || '—'}</td>
                </tr>
              ))}
              {logs.length === 0 && (
                <tr>
                  <td colSpan={5} className={styles.emptyRow}>
                    Sem registos de acesso.
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
